import { apiDelete, apiGet, apiPost } from '.';
import { ReservableEventTemplate, ReservableEventWithTimeslots } from '@go-shared/types/reservable';
import { BareReserveSchedule, ReserveSchedule } from '@go-shared/types/reserveSchedule';

export async function find(propertyId: string): Promise<ReservableEventTemplate[]> {
  return apiGet(`/property/${propertyId}/reservable`);
}

export async function findReservableDetails(
  propertyId: string,
  eventTemplateId: string,
  startDate?: string,
  endDate?: string
): Promise<ReservableEventWithTimeslots> {
  return apiGet(`/property/${propertyId}/reservable/${eventTemplateId}`, {
    startDate,
    endDate,
  });
}

export async function findSchedules(propertyId: string): Promise<ReserveSchedule[]> {
  return apiGet(`/property/${propertyId}/reservable/schedule`);
}

export async function findScheduleByEvent(
  propertyId: string,
  eventTemplateId: string
): Promise<ReserveSchedule> {
  return apiGet(`/property/${propertyId}/reservable/schedule/${eventTemplateId}`, {}, true, false);
}

export async function upsertSchedule(schedule: BareReserveSchedule): Promise<ReserveSchedule> {
  return apiPost(
    `/property/${schedule.property}/reservable/schedule/${schedule.eventTemplate}`,
    schedule
  );
}

export async function deleteScheduleByEvent(
  propertyId: string,
  eventTemplateId: string
): Promise<void> {
  return apiDelete(`/property/${propertyId}/reservable/schedule/${eventTemplateId}`);
}

export async function toggleSlotException(
  propertyId: string,
  eventTemplateId: string,
  params: { ruleId: string; slotId: string; date: string; rental?: string }
): Promise<void> {
  return apiPost(
    `/property/${propertyId}/reservable/schedule/${eventTemplateId}/exception`,
    params
  );
}
